import React, { useState, useEffect } from 'react';
import { Dropdown, Button } from '@themesberg/react-bootstrap';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { getCollectors } from '../../redux/actions/collector';
import { tableTheme } from '../../helpers/tableTheme';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';
import ColorComponent from '../../components/ColorComponent';
import {
  faEllipsisH,
  faEdit,
  faTable,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ViewCollector({ history }) {
  const dispatch = useDispatch();

  const collectorData = useSelector((state) => state.collector.collectorData);

  const columns = [
    {
      name: 'Collector Id',
      label: 'Collector Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'Username',
      label: 'Username',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'Name',
      label: 'Name',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'Email',
      label: 'Email',
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: 'Phone Number',
      label: 'Phone Number',
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: 'Total Customers',
      label: 'Total Customers',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'Status',
      options: {
        customBodyRender: (value) => {
          return <ColorComponent value={value} />;
        },
      },
    },
    {
      name: 'Last batch update',
      label: 'Last batch update',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'Action',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => (
          <Dropdown onClick={(e) => e.stopPropagation()}>
            <Dropdown.Toggle
              as={Button}
              variant='light'
              size='sm'
              className='customToggleDropdown'
              // className="me-2"
            >
              <FontAwesomeIcon
                icon={faEllipsisH}
                style={{
                  color: '#262B40',
                  fontSize: 10,
                }}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu className='dashboard-dropdown dropdown-menu-left mt-2'>
              <Dropdown.Item
                style={{ fontSize: 14 }}
                onClick={() => history.push(`/collectors/profile/${value}`)}
              >
                <FontAwesomeIcon icon={faTable} className='me-2' /> View
                Collector
              </Dropdown.Item>
              <Dropdown.Item
                style={{ fontSize: 14 }}
                onClick={() => history.push(`/collectors/edit/${value}`)}
              >
                <FontAwesomeIcon icon={faEdit} className='me-2' /> Edit
                Collector
              </Dropdown.Item>
              {/* <Dropdown.Divider /> */}
            </Dropdown.Menu>
          </Dropdown>
        ),
      },
    },
  ];

  // const columns =;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getCollectors(false)).then(() => setIsLoading(false));
  }, []);

  const onRowsSelect = (rowData, rowMeta) => {
    history.push(`/collectors/profile/${rowData[0]}`);
  };
  const options = {
    filterType: 'checkbox',
    selectableRowsOnClick: false,
    responsive: 'standard',
    print: false,
    download: false,
    onRowClick: onRowsSelect,
    elevation:0

  };

  return (
    <div>
      <MuiThemeProvider theme={tableTheme}>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <MUIDataTable
            title={'View Collectors'}
            data={collectorData}
            columns={columns}
            options={options}
          />
        )}
      </MuiThemeProvider>
    </div>
  );
}

export default ViewCollector;
